// Keep imports as-is
import * as React from "react";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import NoOfQuestionChart from "./NoOfQuestionChart";
import NoOfSessionChart from "./NoOfSessionChart";
import { FormControl } from '@mui/material';
import { Select } from "antd";
import { useSidebar } from "../../common/SidebarContext";
import dayjs from "dayjs";

const data = ["7 days", "Month", "Year"];
const optionsList = data.map((label) => ({
  value: label.trim().toLowerCase() === "month" || label.trim().toLowerCase() === "year" ? `1${label.trim().toLowerCase()}` : label.trim().toLowerCase(),
  label,
}));

const ActivityOverview = ({ superAdminEmail, id }) => {

  const [questionData, setQuestionData] = React.useState();
  const [sessionData, setSessionData] = React.useState();
  const [selectedOption, setSelectedOption] = React.useState("7 days");
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const [selectedYear, setSelectedYear] = React.useState(dayjs());
  const [chartData, setChartData] = React.useState({});


  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("UserId");

  const { profile } = useSidebar();
  const OrganizationId = profile?.OrganizationId;

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleUserActivity = async () => {
    try {
      const endpoint = `${process.env.REACT_APP_API_ROOT}/api/bot/useractivity/?UserId=${userId}&BotId=${id}&OrganizationId=${OrganizationId}`;

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const dataa = await response.json();
      if (response.ok) {
        setChartData(dataa);
      } else {
        console.log("API Error:", response.status, dataa);
      }
    } catch (error) {
      console.log("Fetch Error:", error.message);
    }
  };

  const handleQuestion = async () => {
    try {
      const base = `${process.env.REACT_APP_API_ROOT}/api/bot`;
      const suffix =
        selectedOption === "7 days"
          ? "useractivityquestiongraph/"
          : selectedOption === "1month"
          ? `useractivityquestiongraphmonthly/?Month=${selectedDate?.$M + 1}&Year=${selectedDate?.$y}`
          : `useractivityquestiongraphannually/?Year=${selectedYear?.$y}`;

      const endpoint = `${base}/${suffix}${suffix =="useractivityquestiongraph/"?"?":"&"}UserId=${userId}&BotId=${id}`;
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const dataa = await response.json();
        setQuestionData(dataa);
      } else {
        console.log("Error:", response.status);
      }
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  const handleSession = async () => {
    try {
      const base = `${process.env.REACT_APP_API_ROOT}/api/bot`;
      const suffix =
        selectedOption === "7 days"
          ? "useractivitysessiongraph/"
          : selectedOption === "1month"
          ? `useractivitysessiongraphmonthly/?Month=${selectedDate?.$M + 1}&Year=${selectedDate?.$y}`
          : `useractivitysessiongraphannually/?Year=${selectedYear?.$y}`;

      const endpoint = `${base}/${suffix}${suffix =="useractivitysessiongraph/"?"?":"&"}UserId=${userId}&BotId=${id}`;
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const dataa = await response.json();
        setSessionData(dataa);
      } else {
        console.log("Error:", response.status);
      }
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  React.useEffect(() => {
    handleUserActivity();
  }, []);

  React.useEffect(() => {
    handleQuestion();
    handleSession();
    handleUserActivity()

  }, [selectedOption, selectedDate, selectedYear,id]);

  React.useEffect(() => {
    if (selectedOption === "1month") {
      setSelectedDate(dayjs());
    } else if (selectedOption === "1year") {
      setSelectedYear(dayjs());
    }
  }, [selectedOption]);

  return (
    <div>
      <div className="flex justify-start items-center gap-2 mt-[2%]">
        <FormControl sx={{ minWidth: 120, mt: 1, mr: "10px" }}>
          <Select
            style={{ height: "55px", lineHeight: "50px" }}
            value={selectedOption}
            options={optionsList}
            onChange={handleOptionChange}
          />
        </FormControl>

        {selectedOption === "1month" && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                value={selectedDate}
                views={["month", "year"]}
                onChange={(newValue) => setSelectedDate(newValue)}
              />
            </DemoContainer>
          </LocalizationProvider>
        )}

        {selectedOption === "1year" && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                views={["year"]}
                value={selectedYear}
                onChange={(newValue) => setSelectedYear(newValue)}
              />
            </DemoContainer>
          </LocalizationProvider>
        )}
      </div>

      <div className="mt-[3%] flex w-full gap-3">
        <div className="flex flex-col gap-1 bg-green-50 justify-center items-center pt-2 pb-4 px-8 rounded-lg border-[0.5px] border-gray-400 border-opacity-60">
          <h1 className="font-medium">{chartData?.message?.Total_Questions ?? 0}</h1>
          <p>Number of Questions</p>
          <img src="/graph.svg" />
        </div>
        <div className="flex flex-col gap-1 bg-green-50 justify-center items-center pt-2 pb-4 px-8 rounded-lg border-[0.5px] border-gray-400 border-opacity-60">
          <h1 className="font-medium">{chartData?.message?.Total_Sessions ?? 0}</h1>
          <p>Number of Sessions</p>
          <img src="/graph.svg" />
        </div>
        <div className="flex flex-col gap-1 bg-green-50 justify-center items-center pt-2 pb-4 px-8 rounded-lg border-[0.5px] border-gray-400 border-opacity-60">
          <h1 className="font-medium">{chartData?.message?.Total_Bots ?? 0}</h1>
          <p>Number of Bots</p>
          <img src="/graph.svg" />
        </div>
      </div>

      <div className="mt-[5%] flex justify-between w-full">
        <div className="w-[48%] bg-[#F0F0F0] p-6 rounded-md border-2 border-gray-400">
          <NoOfQuestionChart chartData={questionData} />
        </div>
        <div className="w-[48%] bg-[#F0F0F0] p-6 rounded-md border-2 border-gray-400">
          <NoOfSessionChart filteredData={sessionData} />
        </div>
      </div>
    </div>
  );
};

export default ActivityOverview;
